export const getPartierAlias = (partier, alias) => {
  let partierAlias = "";
  switch (partier) {
    case "WINDOW_FIXED":
      partierAlias = alias.bfcWindowFixed;
      break;
    case "WINDOW_TOP_FIXED":
      partierAlias = alias.bfcWindowTopFixed;
      break;
    case "WINDOW_TOP_VENT":
      partierAlias = alias.bfcWindowTopVent;
      break;
    case "DOOR":
      partierAlias = alias.bfcDoor;
      break;
    case "DOOR_FIXED":
      partierAlias = alias.bfcDoorFixed;
      break;
    case "DOOR_VENT":
      partierAlias = alias.bfcDoorVent;
      break;
    case "WINDOW":
      partierAlias = alias.bfcWindow;
      break;
    case "PANEL_DOOR":
      partierAlias = alias.bfcPanelDoor;
      break;
    case "EMPTY":
      partierAlias = alias.bfcEmpty;
      break;
    default:
      break;
  }
  return partierAlias;
};
